import React, { useEffect, useState } from 'react';
import './ErrorNotification.css';

const STORAGE_KEY = 'login_error_message';
const STORAGE_TIMESTAMP_KEY = 'login_error_timestamp';
const ERROR_DURATION = 15000; // 15 seconds

const PersistentErrorNotification = () => {
  const [error, setError] = useState(null);
  const [visible, setVisible] = useState(false);

  // Check for stored error on mount and when storage changes
  useEffect(() => {
    const checkStoredError = () => {
      const storedMessage = sessionStorage.getItem(STORAGE_KEY);
      const storedTimestamp = sessionStorage.getItem(STORAGE_TIMESTAMP_KEY);
      
      if (storedMessage && storedTimestamp) {
        const timestamp = parseInt(storedTimestamp, 10);
        const age = Date.now() - timestamp;
        
        if (age < ERROR_DURATION) {
          console.log('[PersistentError] Found stored error:', storedMessage, 'age:', age + 'ms');
          setError(storedMessage);
          setVisible(true);
          
          // Set timeout for remaining duration
          const remainingTime = ERROR_DURATION - age;
          setTimeout(() => {
            clearError();
          }, remainingTime);
        } else {
          // Error too old, clear it
          clearError();
        }
      }
    };

    // Check on mount
    checkStoredError();

    // Listen for storage events (from other windows/tabs)
    const handleStorageChange = (e) => {
      if (e.key === STORAGE_KEY) {
        checkStoredError();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case storage event doesn't fire
    const interval = setInterval(checkStoredError, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const clearError = () => {
    console.log('[PersistentError] Clearing error');
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_TIMESTAMP_KEY);
    setError(null);
    setVisible(false);
  };

  if (!error || !visible) {
    return null;
  }

  return (
    <div className="error-notification" style={{ zIndex: 99999 }}>
      <div className="error-notification-content">
        <span className="error-notification-icon">⚠️</span>
        <span className="error-notification-message">{error}</span>
        <button 
          className="error-notification-close" 
          onClick={clearError}
          aria-label="Schließen"
        >
          ×
        </button>
      </div>
    </div>
  );
};

// Export a function to show errors that can be called from anywhere
export const showPersistentError = (message) => {
  console.log('[PersistentError] Storing error:', message);
  sessionStorage.setItem(STORAGE_KEY, message);
  sessionStorage.setItem(STORAGE_TIMESTAMP_KEY, Date.now().toString());
  
  // Force a storage event for the current window
  window.dispatchEvent(new StorageEvent('storage', {
    key: STORAGE_KEY,
    newValue: message,
    url: window.location.href
  }));
};

export default PersistentErrorNotification;